

import {
    LoadBaseNotifications, LoadBaseNotificationsFail, LoadBaseNotificationsSuccess,
    SetBaseNotificationsAsRead, SetBaseNotificationsAsReadFail, SetBaseNotificationsAsReadSuccess
} from '../base-notification/base-notification.actions';

export enum DocumentNotificationsActionTypes {
    LoadCertificationNotifications = '[Licenses] Load certification notifications',
    LoadCertificationNotificationsSuccess = '[Licenses] Load certification notifications success',
    LoadCertificationNotificationsFail = '[Licenses] Load certification notifications fail',
    LoadPublicHealthRecordNotifications = '[Licenses] Load PublicHealthRecord notifications',
    LoadPublicHealthRecordNotificationsSuccess = '[Licenses] Load PublicHealthRecord notifications success',
    LoadPublicHealthRecordNotificationsFail = '[Licenses] Load PublicHealthRecord notifications fail',
}


export class LoadCertificationNotifications extends LoadBaseNotifications {

}
export class LoadCertificationNotificationsSuccess extends LoadBaseNotificationsSuccess {
}

export class LoadCertificationNotificationsFail extends LoadBaseNotificationsFail {
}

export class LoadPublicHealthRecordNotifications extends LoadBaseNotifications {
}
export class LoadPublicHealthRecordNotificationsSuccess extends LoadBaseNotificationsSuccess {
}
export class LoadPublicHealthRecordNotificationsFail extends LoadBaseNotificationsFail {
}

export class SetCertificationNotificationAsRead extends SetBaseNotificationsAsRead {

}
export class SetCertificationNotificationAsReadSuccess extends SetBaseNotificationsAsReadSuccess {
}

export class SetCertificationNotificationAsReadFail extends SetBaseNotificationsAsReadFail {
}

export class SetPublicHealthRecordNotificationAsRead extends SetBaseNotificationsAsRead {
}
export class SetPublicHealthRecordNotificationAsReadSuccess extends SetBaseNotificationsAsReadSuccess {
}
export class SetPublicHealthRecordNotificationAsReadFail extends SetBaseNotificationsAsReadFail {
}

export type DocumentNotificationsAction =
    LoadCertificationNotifications | LoadCertificationNotificationsSuccess | LoadCertificationNotificationsFail
    | LoadPublicHealthRecordNotifications | LoadPublicHealthRecordNotificationsSuccess | LoadPublicHealthRecordNotificationsFail
    | SetCertificationNotificationAsRead | SetCertificationNotificationAsReadSuccess | SetCertificationNotificationAsReadFail
    | SetPublicHealthRecordNotificationAsRead | SetPublicHealthRecordNotificationAsReadSuccess | SetPublicHealthRecordNotificationAsReadFail
    ;
